<template>

<app-table empty-message="This attendee has not played any games from the library." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />
				
		<app-table-column text="Game" />
				
		<app-table-column align="center" text="Hours" />
				
		<app-table-column align="center" text="Players" />
				
		<app-table-column text="Loaned by" />

		<app-table-column text="Checked Out" />
				
		<app-table-column text="Checked In" />

	</app-table-head>

	<app-table-body>

		<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="$constants.checkout.loan.tagName[item.statusReturn]" :subtext="item.reference" :type="$constants.checkout.loan.tagTheme[item.statusReturn]" />
					
			<app-table-cell-item type="organisation/library/game" :item="item.game" />
					
			<app-table-cell-text align="center" :text="item.hours" />

			<app-table-cell-text align="center" :text="item.players" />

			<app-table-cell-item type="convention/gabadgeme" :item="item.badge" />
					
			<app-table-cell-text :text="item.date.out | localDate('h:mma')" :subtext="item.date.out | localDate('dddd')" />
					
			<app-table-cell-text :can-empty="true" :text="item.date.in | localDate('h:mma')" :subtext="item.date.in | localDate('dddd')" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px minmax(0, 1fr) 80px 80px 240px 140px 140px'
		}
	
	},

	methods: {
	
		onEditClick: function(item) {
		
			this.$router.push({
				name: 'Convention.Checkout.Loans.Edit', 
				params: {
					id: item
				}
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>